import TableBlock from './TableBlock.vue';

[...document.getElementsByClassName("vue-table-block")].forEach(item => {

    const tableId = item.id.replace('table-block-', '');
    const dataScript = document.getElementById(`table-data-${tableId}`);
      
    if (!dataScript) {
      return;
    }
    const props = JSON.parse(dataScript.textContent);
    
    createApp(TableBlock, props).mount(item);

});